export default __webpack_public_path__ + "static/media/338.ca89c53d.png";